import {
  ElementType,
  ReactElement,
  ReactEventHandler,
  SyntheticEvent,
} from 'react'

export interface NavigationLink {
  as?: ElementType
  label: string
  href?: string
  isActive: boolean
  isDisabled?: boolean
  isExternal?: boolean
  isManager?: boolean
  icon?: ReactElement
  onClick?: ReactEventHandler
  subLinks?: NavigationLink[]
  renderAsButton?: boolean
  isBeta?: boolean
}

export interface NavigationProfile extends NavigationLink {
  hasProfileImage: boolean
  imageUrl: string
  name: string
}

export interface NavigationLogo {
  as?: ElementType
  element: ReactElement
  mobileElement?: ReactElement
  href?: string
  renderAsButton?: boolean
  onClick?: (event: SyntheticEvent) => void
}

export enum Size {
  MobileHeight = '64px',
  DesktopHeight = '57px',
  MaxWidth = '1240px',
}
